import { Injectable } from '@angular/core';
import { custom } from 'devextreme/ui/dialog';

export interface customConfirmPopupOption{
  title?:string;
  showTitle?:boolean;
  message?:string;
  messageHtml?:string;
  buttons?:any[];
}

let defaultButtonOptions:any[]=[
  {
    text: "YES",
    type: "default",
    stylingMode: "contained",
    onClick: (e:any) => {
      return "YES";
    }
  },
  {
    text: "NO",
    type: "default",
    stylingMode: "contained",
    onClick: (e:any) => {
      return "NO";
    }
  }
]

@Injectable({
  providedIn: 'root'
})
export class lConfirmationPopupService {

  constructor() { }

  customConfirmDialog(option:customConfirmPopupOption){
    return custom({
      title: option.title??'Please Confirm',
      showTitle: option.showTitle??false,
      messageHtml: option.messageHtml,
      message: option.message,
      buttons: option.buttons??defaultButtonOptions
    });
  }

  
}
